// Observe activity without consuming keyboard events used by the barcode reader.
export function startScreensaver({ target = window, page = document, onShow, onHide,
    delay = 10000, clock = window }) {
    let timer;
    let stopped = false;
    const events = ['pointermove', 'pointerdown', 'mousedown', 'touchstart', 'touchmove',
        'keydown', 'input', 'wheel', 'click', 'focusin'];
    const options = { capture: true, passive: true };
    const reset = () => {
        clock.clearTimeout(timer);
        onHide();
        if (!stopped && !page.hidden) {
            timer = clock.setTimeout(() => {
                if (!stopped && !page.hidden) onShow();
            }, delay);
        }
    };
    events.forEach(event => target.addEventListener(event, reset, options));
    page.addEventListener('visibilitychange', reset);
    target.addEventListener('focus', reset);
    reset();
    return () => {
        stopped = true;
        clock.clearTimeout(timer);
        events.forEach(event => target.removeEventListener(event, reset, options));
        page.removeEventListener('visibilitychange', reset);
        target.removeEventListener('focus', reset);
        onHide();
    };
}
